import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';

import QuantityColumn from '../../../components/columns/quantity-column';
import { messages } from './messages';

const QuantityCollapsed = ({ fulfillmentPlanId }) => {
  const items = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'items',
    }),
  );

  const quantity = items?.reduce((acc, item) => acc + item.quantity, 0);

  return <QuantityColumn quantity={quantity} />;
};

QuantityCollapsed.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};

const QuantityExpanded = ({ fulfillmentPlanId, fulfillmentPlanItemId }) => {
  const items = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'items',
    }),
  );

  const item = items?.find((i) => i.fulfillmentPlanItemId === fulfillmentPlanItemId) ?? {};

  return <QuantityColumn quantity={item.quantity} />;
};

QuantityExpanded.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
  fulfillmentPlanItemId: PropTypes.string.isRequired,
};

export const Quantity = {
  getMessageDescriptor: () => messages.quantity,
  id: 'quantity',

  render: (data, { isExpanded = false } = {}) => {
    if (!isExpanded) {
      return <QuantityCollapsed fulfillmentPlanId={data.id} />;
    }

    return <QuantityExpanded fulfillmentPlanId={data.id} fulfillmentPlanItemId={data.fulfillmentPlanItemId} />;
  },
};
